import useQuestion from "../dialog-components/QuestionDialog";

export function useCloseQuestion() {
  const question = useQuestion();
  return (options?: {
    onYes?: VoidFunction;
    onNo?: VoidFunction;
    onNull?: VoidFunction;
  }) =>
    question(
      "האם אתה בטוח שברצונך לסגור את הטופס?",
      "השינויים לא נשמרו והדבר עלול להוביל למחיקה של מידע",
      {
        confirmText: "כן, עזוב",
        cancelText: "לא, להישאר",
      },
    ).then((result) => {
      if (result) {
        options?.onYes?.();
      } else {
        if (result === null && options?.onNull) {
          options.onNull();
        } else {
          options?.onNo?.();
        }
      }
    });
}
